import api from 'service/api'

const dponetAPI = api.create('dponet')
const dponetAPIWithoutTrait = api.create('dponet', false)

const get = async ({ governanceProjectTemplateId = '', ...params }) => {
  return await dponetAPI.get(
    `/governance_project_templates/${governanceProjectTemplateId}`,
    {
      params,
    },
  )
}

const getByToken = async ({ token = '' }) => {
  return await dponetAPIWithoutTrait.get(
    `/governance_project_templates/show_by_token/${token}`,
  )
}

const consultCompany = async ({ token, cnpj }) => {
  return await dponetAPIWithoutTrait.get(
    `governance_project_templates/${token}/consult_company/${cnpj}`,
  )
}

export default {
  get,
  getByToken,
  consultCompany,
}
